import { render, staticRenderFns } from "./SetUpPassword.vue?vue&type=template&id=546a1b76"
import script from "./SetUpPassword.vue?vue&type=script&lang=js"
export * from "./SetUpPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports